(function ($, Drupal) {
  "use strict";
  const xsBreakpoint = '992',
        headerRegion = '.region-header',
        headerMenu = '.region-header .mobile-content',
        buttonToggle = headerRegion + ' .block-toggle',
        blockRevealSearch = '.reveal-search',
        classShow = 'content-show',
        flyoutToggle = '.open-flyout',
        flyoutActive = 'flyout-active',
        mobileFlyout = 'mobile-flyout',
        collapsableMenu = '.region-footer .menu--footer ul.menu li.menu-item--expanded',
        menuLevelMaster = '.region-header .menu--main ul.menu.menu-level-master',
        utilityMenu = '.region-header .menu--utility ul.menu.menu-level-master';

  /* jQuery to make the header sticky */
  Drupal.behaviors.stickyHeader = {
    attach: function(context, settings) {
      $(once('bind-sticky-header', 'body', context)).each(function() {
        const header = $('header'),
              scrollTop = 400;

        let prevScrollpos = window.scrollY;
        let stickyHeader = function () {
          var currentScrollPos = window.scrollY;
          // Add class when down scroll and current scroll value greater than scrollTop.
          if (prevScrollpos >= currentScrollPos && $(window).scrollTop() > scrollTop) {
            if (!$('html').hasClass(flyoutActive)) {
              header.removeClass('sticky').addClass('sticky-header');
            }
          } else {
            if ($(window).scrollTop() > header.outerHeight() && !$('html').hasClass(flyoutActive)) {
              header.addClass('sticky');
            } else {
              if (!$('html').hasClass(flyoutActive)) {
                header.removeClass('sticky-header');
                header.removeClass('sticky');
              }
            }
          }
          prevScrollpos = currentScrollPos;
        }
        $(window).scroll(function() {
          stickyHeader();
        });
      });
    },
  };

  // Header
  Drupal.behaviors.headerNavBar = {
    attach: function (context, settings) {
      if (once('northmarq-header-nav', 'html').length) {
        if ($(context).find(headerRegion).length) {
          $(buttonToggle).on('click', revealFlyout);
        }
        function revealFlyout(e) {
          const blockToggle = $(this).attr('block-toggle');
          e.preventDefault();
          if ($(this).hasClass(classShow)) {
            headerNavBarReset();
          }
          else {
            // Add focus to search input and keep cursor at the end of text search string.
            var searchInput = $(blockRevealSearch).find('input.form-autocomplete');
            var value = searchInput.val();
            searchInput.focus().val("").val(value);
            $('.' + blockToggle).addClass(classShow);
            $(this).addClass(classShow);
            // if(!$('body').hasClass(flyoutActive)) {
            //   $('body').addClass(flyoutActive);
            // }
            if(!$('html').hasClass(flyoutActive)) {
              $('html').addClass(flyoutActive);
            }
          }
        };
        // Reset
        function headerNavBarReset() {
          $(headerRegion + ' .' + classShow).each(function () {
            $(this).removeClass(classShow);
            $('html').removeClass(flyoutActive);
            // $('body').removeClass(flyoutActive);
          });
        }
        //  Close - When user clicks/taps outside header
        function headerNavBarClose(e) {
          if ((!$(headerRegion).is(e.target) && $(headerRegion).has(e.target).length === 0)) {
            headerNavBarReset();
          }
        }
        $(window).on('click', headerNavBarClose);
      }
    }
  };

  // Mobile Flyout.
  Drupal.behaviors.mobileFlyout = {
    attach: function(context, settings) {
      $(once('bind-click-event-mobile-flyout', flyoutToggle, context)).each(function() {
        $(this).on('click', function() {
          $(this).toggleClass('is-active');
          $(headerMenu).toggleClass("flyout-active");
          // $('body').removeClass(flyoutActive);
          // $('body').removeClass(mobileFlyout);
          // if($(this).hasClass('is-active')) {
          //   $('body').addClass(mobileFlyout);
          // }

          $('html').removeClass(flyoutActive);
          $('html').removeClass(mobileFlyout);
          if($(this).hasClass('is-active')) {
            $('html').addClass(mobileFlyout);
          }
        });
      });
    }
  };

  // Clone utility and main navigation wrapped to use as mobile content.
  Drupal.behaviors.cloneMobileContent = {
    attach: function(context, settings) {
      $(once('bind-clone-mobile-content', headerRegion, context)).each(function() {
        // create div to wrap the cloned content
        const mobileContent = $('<div class="mobile-content" />');

        // append main navigation to mobile content
        const menuMain = $(headerRegion).find('.menu--main').clone();
        $(menuMain).attr('id', $(menuMain).attr('id') + '-cloned');
        $(mobileContent).append(menuMain);

        // If the overview link is a nolink on Desktop,
        // ensure it's still clickable on mobile.
        const overviewLinks = menuMain.find('.sub-menu-level-1 .link-level--1');
        overviewLinks.each(function() {
          // Find the corresponding link in the sub-menu.
          const l2Menu = this.parentElement;
          if (l2Menu) {
            // Assume this link is the first one in the sub-menu.
            const link = l2Menu.querySelector('.sub-menu-level-2 > li > *');
            if (link && link.nodeName !== 'A') {
              // Overview is a link.
              if (this.getAttribute('href')) {
                const clonedLink = this.cloneNode(true);
                clonedLink.innerText = clonedLink.innerText + ' Overview';
                link.parentElement.appendChild(clonedLink);
                link.remove();
              } else {
                // Overview is a nolink, remove the submenu overview link.
                link.parentElement.remove();
              }
            }
          }
        });

        // If there's Level 2 links with children, clone them into the mobile menu.
        // This is so we can still click on them.
        const l2Links = menuMain.find('a.link-level--2');
        l2Links.each(function() {
          const l3SubMenu = this.parentElement.querySelector('.wrapper-menu-level-3 > ul');
          if (l3SubMenu) {
            const li = document.createElement('li');
            li.classList.add('menu-item');
            const link = this.cloneNode(true);
            link.innerText = link.innerText + ' Overview';
            li.append(link);
            l3SubMenu.insertBefore(li, l3SubMenu.firstElementChild);
          }
        });

        // append utility navigation to mobile content
        const menuUtility = $(headerRegion).find('.menu--utility').clone();
        $(menuUtility).attr('id', $(menuUtility).attr('id') + '-cloned');
        $(mobileContent).append(menuUtility);

        $(headerRegion).find('#navigation-bar').prepend(mobileContent);
      });
    }
  }


  // Collapsable menu block.
  Drupal.behaviors.collapseMenu = {
    attach: function(context, settings) {
      const collapseMenu = function () {
        if (window.innerWidth <= xsBreakpoint) {
          $(once('bind-click-event-collapse-menu', collapsableMenu, context)).on('click', function() {
            $(collapsableMenu).not(this).removeClass('is-active').find('.sub-menu').slideUp('slow');
            $(this).toggleClass('is-active').find('.sub-menu').slideToggle('slow');
          });
        }
      }
      collapseMenu();
      $(window).on('resize', Drupal.debounce(collapseMenu, 200, false));
    }
  };

  // Mega menu.
  Drupal.behaviors.megaMenuLevel = {
    attach: function(context, settings) {
      $(once('bind-click-event-menu-main', menuLevelMaster + " li.menu-item", context)).each(function () {
        $(this).on('click', function(e) {
          if (e.target.closest('.sub-menu-level-2') && window.innerWidth > xsBreakpoint) {
            return;
          }
          e.stopPropagation();
          // if(!$('body').hasClass(flyoutActive)) {
          //   $('body').addClass(flyoutActive);
          // }

          // get all links link-level--2 and add tab-index -1 if we are above xsBreakpoint
          if (window.innerWidth > xsBreakpoint) {
            $(menuLevelMaster + " li.menu-item").find('a.link-level--2').attr('tabindex', '-1');
          } else {
            $(menuLevelMaster + " li.menu-item").find('a.link-level--2').removeAttr('tabindex');
          }
          if(!$('html').hasClass(flyoutActive)) {
            $('html').addClass(flyoutActive);
          } else {
            // find a direct descendant of the parent element with the class link-level--0
            if($(this).hasClass('active') && $(this).find('> a.link-level--0').length > 0) {
              $('html').removeClass(flyoutActive);
            }
          }
          if($(this).find('ul').length > 0){
            // Prevent redirect if submenu exists, keep redirection on menu overview link
            if (!e.target.classList.contains('menu-overview-link')) {
              e.preventDefault();
            }
            // Don't do anything if the overview link is not a link.
            if (e.target.classList.contains('menu-overview-link') && e.target.nodeName !== 'A') {
              return;
            }
            if (window.innerWidth <= xsBreakpoint) {
              // On Menu click hide other submenus exept triggering menu parent (For Mobile)
              $(menuLevelMaster + " li").not($(this).parents('li')).not(this).removeClass('active');
              $(this).toggleClass('active');
            }
            else {
              // On Menu click hide other submenus except triggering menu parent and triggering menu itself (For Desktop)
              $(menuLevelMaster + " li").not($(this).parents('li')).not(this).removeClass('active');
              if(!$(this).hasClass('active')){
                if($(this).find('> .link-level--0, > .link-level--1').length > 0) {
                  $(this).addClass('active');
                }
              } else {
                $(this).removeClass('active');
              }
            }
          }

          const expandedSecondTierItem = $(menuLevelMaster + " li.menu-item").find('.sub-menu-level-1 > li.menu-item--expanded.active');

          if (expandedSecondTierItem.length > 0 && window.innerWidth > xsBreakpoint) {
            const scrollHeight = expandedSecondTierItem.find('.wrapper-menu-level-2').first().prop('scrollHeight')
            // get closest sum-menu-level-1
            const wrapperMenuLevel1 = expandedSecondTierItem.closest('.wrapper-menu-level-1');
            // remove any previously set css variable --main-menu-height
            wrapperMenuLevel1.css('--main-menu-height', '');

            // get the scrollHeight of the wrapperMenuLevel1
            let scrollHeightWrapperMenuLevel1 = wrapperMenuLevel1.prop('scrollHeight');
            // set a css variable to the scrollHeight
            // if scrollHeight is greater than scrollHeightWrapperMenuLevel1, use scrollHeight, else use scrollHeightWrapperMenuLevel1
            if (scrollHeight > scrollHeightWrapperMenuLevel1) {
              wrapperMenuLevel1.css('--main-menu-height', scrollHeight + 'px');
            } else {
              // remove 6 rem for padding
              scrollHeightWrapperMenuLevel1 = scrollHeightWrapperMenuLevel1 - 96;
              wrapperMenuLevel1.css('--main-menu-height', scrollHeightWrapperMenuLevel1 + 'px');
            }
          }
        });
      });

      $(once('bind-click-event-menu-main-leave', menuLevelMaster, context)).each(function () {
        $(this).on('mouseleave', function(e) {
          if (window.innerWidth <= xsBreakpoint) {
            return;
          }
          e.stopPropagation();
          if ($(menuLevelMaster + " li.active").length > 0) {
            // $("body").removeClass(flyoutActive);
            $('html').removeClass(flyoutActive);
          }
          $(menuLevelMaster + " li").removeClass('active');
        });
      });

      // Utility menu.
      $(once('bind-click-event-utility-main', utilityMenu + " li.menu-item", context)).each(function () {
        $(this).on('click', function(e) {
          e.stopPropagation();
          // Prevent redirect if submenu exists, keep redirection on menu overview link
          if($(this).find('ul').length > 0 && !e.target.classList.contains('menu-overview-link')){
            e.preventDefault();
          }

          if($(this).find('ul').length > 0){
            if (window.innerWidth <= xsBreakpoint) {
              // On Menu click hide other submenus exept triggering menu parent (For Mobile)
              $(utilityMenu + " li").not($(this).parents('li')).not(this).removeClass('active');
              $(this).toggleClass('active');
            }
          }
        });
      });
    }
  };

  // Copyrights block year
  Drupal.behaviors.copyrightDate = {
    attach: function (context, settings) {
      $('#copyright-year', context).html(new Date().getFullYear());
    }
  };


  Drupal.behaviors.morphLegacyMultiFamilyListingPageLinks = {
    attach: function (context, settings) {
      // Find links with listings.northmarq.com in the href using 'once'
      const links = once('morph-legacy-links', 'a[href*="listings.northmarq.com"]', context);

      // Check if the body has the class 'user-logged-in'
      const isUserLoggedIn = $('body').hasClass('user-logged-in');

      $(links).each(function(i, el) {
        // Exclude links inside elements with the class '.node--type-listing'
        if (!$(el).closest('.node--type-listing').length) {

          // Morph links only if the user is not logged in
          if (isUserLoggedIn) {
            // if ($(el).attr('href').includes('type=4746')) {
            //   $(el).attr('href', '/properties?property_type%5B1%5D=3336');
            // } else if ($(el).attr('href').includes('listings.northmarq.com/land-listings')) {
            //   $(el).attr('href', '/properties?property_type[]=866&property_type[]=921');
            // } else if ($(el).attr('href').includes('listings.northmarq.com/mhc-listings')) {
            //   $(el).attr('href', '/properties?property_type%5B1%5D=961');
            // } else {
            //   $(el).attr('href', '/properties?property_type%5B1%5D=921');
            // }
          } else {
            // $(el).attr('href', '/properties?property_type%5B1%5D=921');
          }
        }
      });
    }
  };

  Drupal.behaviors.forceReloadPage = {
    attach: function (context, settings) {
      const links = once('bind-reload', 'a[href*="?reload=1"]', context);
      $(links).on('click', function(event) {
        event.preventDefault();
        // get pathname of the current page
        const pathname = window.location.pathname;
        // get the pathname of the href. should be the url without the domain, without the protocol and without the query string
        const href = $(this).attr('href');
        // remove query string and jumplinks from href
        const hrefWithoutQuery = href.split('?')[0];
        // check if the href is the same as the current page
        if (pathname === hrefWithoutQuery) {
          // reload the page
          location.reload();
        } else {
          // redirect to the href
          window.location = href;
        }
      });
    }
  };

  Drupal.behaviors.smoothScroll = {
    attach: function (context, settings) {
      const jumpLinks = once('bind-smooth-scroll', 'a[href*="#"]:not(.no-smooth-scroll)', context);
      $(jumpLinks).on('click', function (event) {
        const hash = this.hash;
        if (!hash) {
          return;
        }

        // Do not auto-scroll the page when clicking sidebar section headers (tab toggles).
        // Individual rate-table links (.more-link) should still smooth-scroll.
        if (this.closest('.layout-sidebar') && this.dataset.bsToggle === 'tab') {
          event.preventDefault();
          return;
        }

        // If the link points to a different page (or different origin), allow normal navigation.
        // Only smooth-scroll for same-page anchors.
        try {
          const url = new URL(this.href, window.location.href);
          if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) {
            return;
          }
        } catch (e) {
          // If parsing fails, do not interfere with navigation.
          return;
        }

        // Same-page anchor, run smooth scroll.
        event.preventDefault();

        if (hash !== '' && $(hash).length > 0) {
          const targetOffset = $(hash).offset().top;
          $('html, body').stop().animate(
            {
              scrollTop: targetOffset,
            },
            150,
            'linear',
            function () {
              // Only update the hash if it has changed.
              if (window.location.hash !== hash) {
                window.location.hash = hash;
              }
            }
          );
        }
      });
    },
  };

  Drupal.behaviors.tabled = {
    attach: function (context, settings) {
      function updateTableMode() {
        var screenWidth = $(window).width();
        var $table = $('table.tablesaw');

        if (screenWidth < 679) {
          // Switch to stacked mode below 992px
          $table.attr('data-tablesaw-mode', 'stack'); // Set swipe mode
          $table.addClass('tablesaw-stack'); // Add stack class
          $table.removeClass('tablesaw-swipe'); // Remove stack class
        } else {
          // Switch to swipe mode above 992px
          $table.attr('data-tablesaw-mode', 'swipe'); // Set swipe mode
          $table.addClass('tablesaw-swipe'); // Add stack class
          $table.removeClass('tablesaw-stack'); // Remove stack class
        }

        // Reinitialize Tablesaw
        $(document).trigger("enhance.tablesaw");
        document.querySelectorAll('.tablesaw-cell-label').forEach(function(el) {
          // Check if the element contains only &nbsp; or a non-breaking space
          if (el.innerHTML.trim() === '&nbsp;' || el.textContent.trim() === '\u00A0') {
            // Remove the non-breaking space by clearing the innerHTML
            el.innerHTML = '';
          }
        });
      }

      // Run on page load
      updateTableMode();

      // Run on window resize
      $(window).resize(function() {
        updateTableMode();
      });
    },
  };

  Drupal.behaviors.copyLink = {
    attach: function (context, settings) {
      // find .a2a_button_copy_link
      const copyLink = once('bind-copy-link', '.a2a_button_copy_link', context);
      // add a hidden tooltip <span id="copyTooltip" style="display:none;">Copied!</span> inside the copyLink
      $(copyLink).append('<span id="copyTooltip" style="display:none;">Copied!</span>');
      // remove other click events
      $(copyLink).off('click');
      // add click event
      $(copyLink).on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        // get the current url and copy it to the clipboard
        var url = window.location.href;
        navigator.clipboard.writeText(url).then(function() {
          // show the tooltip
          var tooltip = document.getElementById("copyTooltip");
          $('#copyTooltip').fadeIn(400).delay(2000).fadeOut(400);
        }, function(err) {
          console.error('Async: Could not copy text: ', err);
        });
      });
    }
  };

  Drupal.behaviors.fileQueryParam = {
    attach: function (context, settings) {
      // txt, doc, docx, pdf, pptx, ics, mp4
      const links = once('file-query-param', 'a[href$=".pdf"]', context);
      links.forEach(function(link) {
        const href = link.getAttribute('href');
        link.setAttribute('href', `${href}?u=${new Date().getMilliseconds()}`);
      });
    }
  };

  Drupal.behaviors.utmWebformTracking = {
    attach: function (context, settings) {
      let searchParams = window.location.search;
      // find and window.facadeUrlParams
      if (window.facadeUrlParams) {
        const facadeUrlParams = window.facadeUrlParams;
        // turn facadeUrlParams into a query string
        const queryParamString = Object.keys(facadeUrlParams).map(key => `${key}=${facadeUrlParams[key]}`).join('&');

        if (searchParams.length === 0) {
          searchParams += `?${queryParamString}`;
        } else {
          searchParams += `&${queryParamString}`;
        }
      }

      const params = new URLSearchParams(searchParams);

      // merge queryParamString and params


      const keys = [
        'utm_source',
        'utm_name',
        'utm_medium',
        'utm_content',
        'utm_campaign',
        'listing_id',
        'listing_url',
        'listing_name',
        'property_type',
        'property_sub_type',
        'location',
        'lead_source'
      ];

      keys.forEach(key => {
        const value = params.get(key);
        if (!value) return;

        // Find all hidden inputs with matching name.
        const inputs = once('utmWebformTracking', `input[type="hidden"][name="${key}"]`, context);
        $(inputs)
          .each((i, el) => {
            $(el).val(value);
          });
      });
    }
  };

  Drupal.behaviors.hiddenInfoWebformTracking = {
    attach: function (context, settings) {
      const links = once('hiddenInfoWebformTracking', '.card-hover--advisor-link .financing-link' , context);

      $(links).each((i, el) => {
        const element = $(el);

        element.on('contextmenu', function (e) {
          e.preventDefault();
          // Trigger the same behavior as a normal click (use-ajax will intercept).
          $(this).trigger('click');
        });

        element.click((e) => {
          // get data-listing-id and data-listing-url
          const leadSource = element.data('lead-source');

          // get the anchor text
          const anchorText = element.text().trim();

          dataLayer.push({
            'event': 'talkToExpertCTA',
            'leadSource': leadSource,
            'ctaText': anchorText,
          });

          // put the keys and values in a windows.facadeUrlParams
          window.facadeUrlParams = {
            'lead_source': leadSource,
          };
        });
      });
    }
  };
  Drupal.behaviors.openExternalAndDocumentsInNewTab = {
    attach: function (context, settings) {
      for (let links = document.links, i = 0, a; (a = links[i]); i++) {
        // Do not modify links inside forms.
        if (a.closest('form')) {
          continue;
        }

        if (a.host !== window.location.host || a.href.includes('sites/default/files')) {
          a.target = '_blank';
          a.setAttribute('rel', 'nofollow');
        }
      }
    },
  };

  Drupal.behaviors.utmWebformTracking = {
    attach: function (context, settings) {
      let searchParams = window.location.search;
      // find and window.facadeUrlParams
      if (window.facadeUrlParams) {
        const facadeUrlParams = window.facadeUrlParams;
        // turn facadeUrlParams into a query string
        const queryParamString = Object.keys(facadeUrlParams).map(key => `${key}=${facadeUrlParams[key]}`).join('&');

        if (searchParams.length === 0) {
          searchParams += `?${queryParamString}`;
        } else {
          searchParams += `&${queryParamString}`;
        }
      }

      const params = new URLSearchParams(searchParams);

      // merge queryParamString and params


      const keys = [
        'utm_source',
        'utm_name',
        'utm_medium',
        'utm_content',
        'utm_campaign',
        'listing_id',
        'listing_url',
        'listing_name',
        'property_type',
        'property_sub_type',
        'location',
        'lead_source',
      ];

      keys.forEach(key => {
        const value = params.get(key);
        if (!value) return;

        // Find all hidden inputs with matching name.
        const inputs = once('utmWebformTracking', `input[type="hidden"][name="${key}"]`, context);
        $(inputs)
          .each((i, el) => {
            $(el).val(value);
          });
      });
    }
  };
})(jQuery, Drupal);



Drupal.behaviors.northmarqClearSearch = {
  attach(context) {
    once('clear-search', 'form .clear-search-button', context).forEach((clearButton) => {
      const submitButton = clearButton.closest('form').querySelector('[type="submit"]:not(.search-button)');
      function clearSearch(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        // clear the text input in the .search-input-wrapper container
        const wrapper = e.target.closest('.search-input');
        if (wrapper) {
          const input = wrapper.querySelector('input[type="text"]');
          if (input) {
            input.value = '';
            submitButton.click();
          }
        }
        return false;
      }

      clearButton.addEventListener('click', (e) => {
        clearSearch(e);
      }, false);

      clearButton.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          clearSearch(e);
        }
      }, false);
    });
  },
};
